module.exports = __webpack_public_path__ + "static/media/pattern.d5decd4d.svg";